/**
 * One place that decides whether BOS is allowed to make sound.
 *
 * BOS is MUTED BY DEFAULT. Voice is opt-in, never opt-out.
 *
 * The first customer install shipped with unsolicited text-to-speech on every
 * assistant reply and no way to turn it off anywhere in the product. The owner's
 * words on the onboarding call, 2026-08-10: "there's nothing that gives me the
 * opportunity to mute it from talking back to me. If I just wanted to have chat".
 * A later reply reading the word "done" aloud startled her mid-call.
 *
 * Every surface that can speak (Office, Dashboard, Board, AgentWorkspace,
 * VoiceControl) must consult isVoiceEnabled() before producing audio, so a muted
 * install is silent everywhere rather than silent in the one place someone
 * remembered to check.
 */
const KEY = 'boss_voice_enabled';

/** Muted unless the owner has explicitly opted in. Absent value means muted. */
export function isVoiceEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false; // private mode, storage blocked: stay silent
  }
}

export function setVoiceEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0');
  } catch {
    /* storage blocked; the session simply stays at its default */
  }
  if (!enabled) stopSpeaking();
}

/** Silence anything already talking. Safe to call when nothing is. */
export function stopSpeaking(audio?: HTMLAudioElement | null): void {
  try {
    window.speechSynthesis?.cancel();
  } catch {
    /* unsupported */
  }
  try {
    audio?.pause();
  } catch {
    /* already gone */
  }
}
